/* eslint-disable no-underscore-dangle */

import { JsonObj } from '@mhp/general-interface';

/**
 * Method: getData
 * @description returns AWSDK promise response object data[] or the response as a whole.
 * @param {*} res AWSDK promise response object
 */
export const getData = (res?: JsonObj): JsonObj | undefined => {
  if (!res) return undefined;
  return res.__data ? getData(res.__data) : res;
};
